import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';

export interface Template {
  id: string;
  setor: string;
  etapa: string;
  corpo: string;
  ativo: boolean;
  criado_em: string;
}

export function useTemplates() {
  return useQuery({
    queryKey: ['templates'],
    queryFn: () => n8nFetch<Template[]>('/templates'),
  });
}

interface TemplateUpsertInput {
  id?: string;
  payload: {
    setor: string;
    etapa: string;
    corpo: string;
    ativo?: boolean;
  };
}

export function useTemplateUpsert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: TemplateUpsertInput) => {
      return n8nFetch<Template>('/template-upsert', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['templates'] });
    },
  });
}
